import { PartPriceService } from "@common/client"
import { makeAxiosMutation, makeQuery } from "./utils"

const PART_PRICE_PAGE_SIZE = 500

export const partPricesBaseKey = ["part-prices"] as const

export const partPricesKey = (partId: string) =>
  [...partPricesBaseKey, "list", partId] as const

export const partPricesQuery = makeQuery({
  serviceCall: (partId: string) =>
    PartPriceService.listPrices({
      part_id: partId,
      limit: PART_PRICE_PAGE_SIZE,
    }),
  queryKey: partPricesKey,
})

export const useCreatePartPriceMutation = makeAxiosMutation({
  serviceCall: PartPriceService.create,
  invalidates: () => [partPricesBaseKey],
})

export const useUpdatePartPriceMutation = makeAxiosMutation({
  serviceCall: PartPriceService.update,
  invalidates: () => [partPricesBaseKey],
})

export const useDeletePartPriceMutation = makeAxiosMutation({
  serviceCall: PartPriceService.delete,
  invalidates: () => [partPricesBaseKey],
})
